export default {"src":"/_next/static/media/favicon.0c1a5582.svg","height":512,"width":512};